import * as React from 'react'
import { Box } from "@mui/material"
import { formatPercentage } from "@ui-seeker/utils"


export default function diffColumn() {
	return {
		name: 'diffPrice', label: 'Change %',
		options: {
			headerAlign: 'center',
			setCellProps: () => ({ sx: { minWidth: '100px' }}),
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
				{ !!value ? <Box component="span" sx={{ ml: 1, fontSize: 12, color: value >= 0 ? 'success.main' : 'error.main'}}>
					{formatPercentage(value)}
				</Box> : '-' }
			</Box>
		}
	}
}